import { render } from "./Template.vue?vue&type=template&id=543d3387&scoped=true"
import script from "./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue?vue&type=script&lang=js"

import "./Template.vue?vue&type=style&index=0&id=543d3387&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543d3387"]])

export default __exports__